<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.5,3.5L5,0L6.5,3.5L10,5L6.5,6.5L5,10L3.5,6.5L0,4.99485L3.5,3.5ZM10.8,10.7963L12,8L13.2,10.7963L16,12L13.2,13.1931L12,16L10.8,13.1931L8,11.9959L10.8,10.7963Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Clean',
} as DefineComponent
</script>
